import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './styles';

export function LetterSquare({ letter, isEmpty, size, marginLeft }) {
  const responsiveStylesForLetter = StyleSheet.create({
    blankedText: {
      fontSize: size / 1.35,
    },
    blankedLetterWrapperStyle: {
      width: size,
      height: size,
      marginLeft: marginLeft,
    },
  });

  return (
    <View
      style={[
        !isEmpty && styles.container,
        responsiveStylesForLetter.blankedLetterWrapperStyle,
      ]}
    >
      {isEmpty ? null : (
        <Text
          style={[
            styles.text,
            styles.fontAbz,
            responsiveStylesForLetter.blankedText,
          ]}
        >
          {letter}
        </Text>
      )}
    </View>
  );
}
